// pages/Offerwall/index.styled.ts
import { styled } from 'styled-components';

export const Wrapper = styled.div`
  gap: 10px;
  display: flex;
  flex-direction: column;
`;

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 20px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const StatsContainer = styled.div`
  display: flex;
  gap: 24px;
`;

export const StatCard = styled.div`
  padding: 16px 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  min-width: 160px;
  
  .ant-statistic-title {
    color: #6c757d;
    font-size: 14px;
    margin-bottom: 8px;
  }
  
  .ant-statistic-content {
    color: #495057;
    font-weight: 600;
  }
  
  .ant-statistic-content-value {
    font-size: 24px;
  }
  
  .ant-statistic-content-suffix {
    font-size: 16px;
    color: #6c757d;
  }
`;

export const DateSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CountContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CounterSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;
`;

export const DailyCount = styled.span`
  font-size: 14px;
  color: #1890ff;
  font-weight: 600;
  
  a {
    color: #1890ff;
    text-decoration: none;
    
    &:hover {
      color: #40a9ff;
      text-decoration: underline;
    }
  }
`;

export const TotalCount = styled.span`
  font-size: 14px;
  color: #52c41a;
  font-weight: 600;
  
  a {
    color: #52c41a;
    text-decoration: none;
    
    &:hover {
      color: #73d13d;
      text-decoration: underline;
    }
  }
`;

interface VisibilityTagProps {
    visible: boolean;
}

export const VisibilityTag = styled.div<VisibilityTagProps>`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: ${props => props.visible ? 'pointer' : 'pointer'};
  user-select: none;
  transition: all 0.2s ease;
  
  background-color: ${props => props.visible ? '#52c41a' : '#ff4d4f'};
  color: white;
  
  &:hover {
    opacity: 0.8;
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  color: #1890ff;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  transition: all 0.2s;
  
  &:hover {
    background-color: #f0f5ff;
    color: #40a9ff;
  }
  
  &:active {
    background-color: #e6f7ff;
  }
`;

export const StatusIndicator = styled.div<{ status: 'active' | 'inactive' | 'pending' }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  
  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${props => {
        switch (props.status) {
            case 'active': return '#52c41a';
            case 'inactive': return '#ff4d4f';
            case 'pending': return '#faad14';
            default: return '#d9d9d9';
        }
    }};
  }
`;

export const TableHeader = styled.div`
  display: flex;
  justify-content: between;
  align-items: center;
  margin-bottom: 16px;
  
  h2 {
    margin: 0;
    color: #262626;
    font-size: 20px;
    font-weight: 600;
  }
`;

export const FilterSection = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 16px;
  padding: 16px;
  background: #fafafa;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
`;

export const FilterLabel = styled.span`
  font-size: 14px;
  color: #595959;
  font-weight: 500;
  min-width: 60px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #8c8c8c;
  
  .ant-empty-image {
    margin-bottom: 16px;
  }
  
  .ant-empty-description {
    font-size: 14px;
  }
`;

export const LoadingOverlay = styled.div`
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  }
`;

// 반응형 디자인
export const ResponsiveContainer = styled.div`
  @media (max-width: 768px) {
    ${HeaderSection} {
      flex-direction: column;
      gap: 16px;
      align-items: stretch;
    }
    
    ${StatsContainer} {
      flex-direction: column;
      gap: 12px;
    }
    
    ${DateSection} {
      justify-content: center;
    }
  }
`;

// 툴팁 스타일
export const CustomTooltip = styled.div`
  .ant-tooltip-inner {
    background: #001529;
    border-radius: 6px;
  }
  
  .ant-tooltip-arrow::before {
    background: #001529;
  }
`;